// Purchase Plan and Cancel Purchase share one backend table (plan_purchase),
// so the views are shared too and driven by this per-operation config.
export const PLAN_PURCHASE_OPERATIONS = {
  purchase_plan: {
    operation: "purchase_plan",
    title: "Purchase Plan",
    route: "/pwg/purchase_plan",
    submitLabel: "Purchase Plan",
    queueMessage: "Purchase plan queue started",
    format: "MDN[,STREET1,STREET2,CITY,STATE,ZIP]",
  },
  cancel_purchase: {
    operation: "cancel_purchase",
    title: "Cancel Purchase",
    route: "/pwg/cancel_purchase",
    submitLabel: "Cancel Purchase",
    queueMessage: "Cancel purchase queue started",
    format: "MDN[,PURCHASE_ID]",
  },
};
